import { Container } from './styles'

const Header = () => (
  <Container>
    <div className="container"></div>
  </Container>
)

export default Header
